/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Dirs_Tooltip_DeleteInputs */

const es_settings_dirs_tooltip_delete = /** @type {(inputs: Settings_Dirs_Tooltip_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar carpeta`)
};

const en_settings_dirs_tooltip_delete = /** @type {(inputs: Settings_Dirs_Tooltip_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete directory`)
};

/**
* | output |
* | --- |
* | "Delete directory" |
*
* @param {Settings_Dirs_Tooltip_DeleteInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_tooltip_delete = /** @type {((inputs?: Settings_Dirs_Tooltip_DeleteInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Tooltip_DeleteInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_tooltip_delete(inputs)
	return en_settings_dirs_tooltip_delete(inputs)
});
export { settings_dirs_tooltip_delete as "settings.dirs.tooltip.delete" }